import React from 'react';
import { motion } from 'framer-motion';
import { LeadForm } from './LeadForm';
export function Hero() {
  return <section className="relative bg-brand-dark pt-6 pb-10 lg:pt-20 lg:pb-28 overflow-hidden" data-id="element-103">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-104">
        {/* DESKTOP LAYOUT — two columns, unchanged */}
        <div className="hidden lg:grid lg:grid-cols-2 gap-8 items-center" data-id="element-105">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-106">
            <div className="inline-block bg-white/10 text-white border border-white/10 font-medium px-4 py-1.5 rounded-full text-sm mb-6" data-id="element-107">
              $3,000 Off Invisalign — Limited Time
            </div>

            <h1 className="text-6xl font-light text-white leading-tight mb-6" data-id="element-108">
              Get the Straight, Confident Smile You've Been Putting Off
            </h1>

            <p className="text-xl text-white/70 mb-8 leading-relaxed" data-id="element-109">
              Dr. Julio Lima has helped Miami Lakes families smile with
              confidence for over 35 years. Your free consultation is waiting.
            </p>

            <div className="flex items-center gap-4 text-sm text-white/50" data-id="element-110">
              <div className="flex -space-x-2" data-id="element-111">
                {['https://randomuser.me/api/portraits/women/44.jpg', 'https://randomuser.me/api/portraits/men/32.jpg', 'https://randomuser.me/api/portraits/women/68.jpg', 'https://randomuser.me/api/portraits/men/75.jpg'].map((src, i) => <div key={i} className="w-8 h-8 rounded-full border-2 border-brand-dark overflow-hidden" data-id="element-112">
                    <img src={src} alt="Happy patient" className="w-full h-full object-cover" data-id="element-113" />
                  </div>)}
              </div>
              <p data-id="element-114">Join 2,000+ happy patients in Miami Lakes</p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative z-10" data-id="element-115">
            <LeadForm data-id="element-116" />
          </motion.div>
        </div>

        {/* MOBILE LAYOUT — single column, centered, form after title */}
        <div className="lg:hidden flex flex-col items-center text-center" data-id="element-117">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-118">
            <div className="inline-block bg-white/10 text-white border border-white/10 font-medium px-3 py-1 rounded-full text-xs mb-4" data-id="element-119">
              $3,000 Off Invisalign — Limited Time
            </div>

            <h1 className="text-3xl md:text-5xl font-light text-white leading-tight mb-5" data-id="element-120">
              Get the Straight, Confident Smile You've Been Putting Off
            </h1>
          </motion.div>

          {/* Form right after headline on mobile */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="w-full mb-6" data-id="element-121">
            <LeadForm data-id="element-122" />
          </motion.div>

          {/* Supporting text + trust indicators below form */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="flex flex-col items-center" data-id="element-123">
            <p className="text-sm text-white/70 mb-4 leading-relaxed max-w-md lg:text-lg lg:mb-8" data-id="element-124">
              Dr. Julio Lima has helped Miami Lakes families smile with
              confidence for over 35 years. Your free consultation is waiting.
            </p>

            <div className="flex items-center gap-3 text-sm text-white/50" data-id="element-125">
              <div className="flex -space-x-2" data-id="element-126">
                {['https://randomuser.me/api/portraits/women/44.jpg', 'https://randomuser.me/api/portraits/men/32.jpg', 'https://randomuser.me/api/portraits/women/68.jpg', 'https://randomuser.me/api/portraits/men/75.jpg'].map((src, i) => <div key={i} className="w-8 h-8 rounded-full border-2 border-brand-dark overflow-hidden" data-id="element-127">
                    <img src={src} alt="Happy patient" className="w-full h-full object-cover" data-id="element-128" />
                  </div>)}
              </div>
              <p data-id="element-129">Join 2,000+ happy patients in Miami Lakes</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}